import {apiClient} from '@common/http/query-client';
import {useEffect} from 'react';
import {
  PluginRuntimeDescriptor,
  setRuntimePlugins,
} from './plugin-runtime-registry';

let loadPromise: Promise<void> | null = null;

export function loadPluginRuntime(): Promise<void> {
  if (!loadPromise) {
    loadPromise = apiClient
      .get<{plugins: PluginRuntimeDescriptor[]}>('plugins/runtime')
      .then(async response => {
        const plugins = Array.isArray(response.data?.plugins)
          ? response.data.plugins
          : [];
        setRuntimePlugins(plugins);

        for (const plugin of plugins) {
          if (plugin.style) addStylesheet(plugin);
          try {
            await import(/* @vite-ignore */ plugin.entry);
          } catch (error) {
            console.error(
              `Could not load frontend for plugin ${plugin.slug}.`,
              error,
            );
          }
        }
        setRuntimePlugins(plugins);
      })
      .catch(error => {
        setRuntimePlugins([]);
        console.error('Could not load the plugin frontend runtime.', error);
      });
  }

  return loadPromise;
}

function addStylesheet(plugin: PluginRuntimeDescriptor) {
  if (
    !plugin.style ||
    document.querySelector(`link[data-plugin-style="${plugin.slug}"]`)
  ) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = plugin.style;
  link.dataset.pluginStyle = plugin.slug;
  document.head.append(link);
}

export function PluginRuntimeLoader() {
  useEffect(() => {
    loadPluginRuntime();
  }, []);

  return null;
}
